import { render, staticRenderFns } from "./AddIcon.vue?vue&type=template&id=e11cb8d0&"
import script from "./AddIcon.vue?vue&type=script&lang=js&"
export * from "./AddIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports